import { createSelector } from '@ngrx/store';
import { selectPaymentsAndStatementsState } from '../reducers';
import * as fromClosePaymentRun from '../reducers/close-payment-run.reducer';

export { ClosePaymentRunState } from '../reducers/close-payment-run.reducer';

export const selectClosePaymentRunState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromClosePaymentRun.closePaymentRunFeatureKey]
);

export const selectClosePaymentRunSuccess = createSelector(
  selectClosePaymentRunState,
  (state) => state?.success
);

export const selectClosePaymentRunFailure = createSelector(
  selectClosePaymentRunState,
  (state) => state?.failure
);

export const selectClosePaymentRunLoading = createSelector(
  selectClosePaymentRunState,
  (state) => state?.loading
);
